export const base = '/faq';
